var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 9.99996L9.99935 7.99996M9.99935 7.99996L7.99935 5.99996M9.99935 7.99996H2.66602M2.66602 4.83197V4.80009C2.66602 4.05335 2.66602 3.67971 2.81134 3.39449C2.93917 3.14361 3.143 2.93978 3.39388 2.81195C3.6791 2.66663 4.05274 2.66663 4.79948 2.66663H11.1995C11.9462 2.66663 12.3191 2.66663 12.6043 2.81195C12.8551 2.93978 13.0597 3.14361 13.1875 3.39449C13.3327 3.67943 13.3327 4.05262 13.3327 4.7979V11.2024C13.3327 11.9476 13.3327 12.3203 13.1875 12.6052C13.0597 12.8561 12.8551 13.0603 12.6043 13.1881C12.3193 13.3333 11.9467 13.3333 11.2014 13.3333H4.79729C4.05201 13.3333 3.67882 13.3333 3.39388 13.1881C3.143 13.0603 2.93917 12.8559 2.81134 12.605C2.66602 12.3198 2.66602 11.9467 2.66602 11.2V11.1666",
    stroke: "#6130B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginFilled);
export default __webpack_public_path__ + "static/media/login-filled.fe6daa2ede9ebfc86648158344c9a40f.svg";
export { ForwardRef as ReactComponent };